// Converts snake_case (and similar) to sentence case: "example_text" -> "Example text"
export function snakeToSentence(input?: string | null): string {
  if (!input) return "";
  // Replace underscores/hyphens with spaces, collapse multiple spaces, lower-case, capitalize first letter
  const normalized = input
    .replace(/[\-_]+/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase();
  return capitalize(normalized);
}

// Capitalizes the first letter of a string: "example" -> "Example"
export function capitalize(input?: string | null): string {
  if (!input) return "";
  return input.charAt(0).toUpperCase() + input.slice(1);
}
